/*
 * axios封装
 * */
import { Message } from "element-ui";
import { basicParam, PasWord } from "../data/basicParam.js";
import { API_URL } from "../data/Url.js";

export default function(service, options) {
    let that = this;
    // let host=window.location.host,apiurl=API_URL[host]?API_URL[host].api:API_URL["localhost"].api
    let random = Math.round(Math.random() * 10000);
    //时间戳
    let timestamp = Date.parse(new Date());
    let Requestheader = {
        'app_id': '619379435910168',
        'app_secret': 'bIkznbB7HP46AzRsLzX3hHAbbkQ7Gf',
        "spid": "619379435910168",
        "ts": timestamp,
    }
    let datastr = Object.assign(options, basicParam, { random: random });
    datastr.ts = Requestheader.ts;
    datastr.service = service;
    if (localStorage.getItem('token')) {
        datastr.token = localStorage.getItem('token');
    } else {
        datastr.token = '';
    }
    var res1 = Object.keys(datastr).sort(); //按字典排序
    let str = "";
    for (var key in res1) {
        if (key == res1.length - 1) {
            str += res1[key] + '=' + datastr[res1[key]]
        } else {
            str += res1[key] + '=' + datastr[res1[key]] + '&'
        }
    }
    let sign = hex_md5(str + Requestheader.app_secret).toString().toUpperCase()
    options.sign = sign;
    delete options.app_id
    delete options.app_secret
    delete options.ts
    options.service = service;
    options.token = localStorage.getItem('token')
    return axios({
        url: API_URL,
        method: "post",
        headers: {
            'app_id': '619379435910168',
            'app_secret': 'bIkznbB7HP46AzRsLzX3hHAbbkQ7Gf',
            "spid": "619379435910168",
            "ts": timestamp,
            'sign': sign
        },
        data: Object.assign(options, basicParam, { random: random })
    }).then(function(res) {
        if (res.data.succ) {
            return res.data
        } else {
            if (res.data.code == "00000010") {
                Message({
                    showClose: true,
                    message: '您的账号在其他设备登录,请重新登录',
                    type: "warning"
                });
                localStorage.removeItem("docId");
                localStorage.removeItem("userInfo");
                localStorage.removeItem("token");
                that.$router.push("/login");
                //window.location = HOST_URL;
            } else {
                Message({
                    showClose: true,
                    message: res.data.msg,
                    type: "error"
                });
            }

            return res.data
        }
    }).catch(function(err) {

    });
}